//The hierarchy of content starts from the Home page all the way to the Contact page

const PAGE_CONTENT = [
  {
    id: 0,
    contentHeading: "Welcome To BNMPCITC Presents Benchmark ",
    contentDescription:
      "Join us for an extensive three day online festival packed with challenging and entertaining events and games. Participate in online events and win amazing prizes and be a part of the BNMPC IT Club Community!",
  },

  {
    id: 1,
    contentHeading: `What is all this hype about Benchmark?`,
    contentDescription:
      "Locavore cardigan small batch roof party blue bottle blog meggings sartorial jean shorts kickstarter migas sriracha church-key synth succulents. Actually taiyaki neutra, distillery gastropub pok pok ugh.",
  },

  {
    id: 2,
    contentHeading: "Bring Your Talents to the Table",
    contentDescription:
      "Benchmark isn't just any online event. It will let you bring out your inner potential and let you get creative with just about anything because we focus on the following things",
  },

  {
    id: 3,
    contentHeading: "Event Details",
    contentDescription:
      "Whatever cardigan tote bag tumblr hexagon brooklyn asymmetrical gentrify, subway tile poke farm-to-table.",
  },
  {
    id: 4,
    contentHeading: "BNMPC IT CLUB",
    contentDescription:
      "Meggings kinfolk echo park stumptown DIY, kale chips beard jianbing tousled. Chambray dreamcatcher trust fund, kitsch vice godard disrupt ramps hexagon mustache umami snackwave tilde chillwave ugh. Pour-over meditation PBR&B pickled ennui celiac mlkshk freegan photo booth af fingerstache pitchfork.",
  },
  {
    id: 5,
    contentHeading: "What We Offer to the Students",
    contentDescription:
      "Meggings kinfolk echo park stumptown DIY, kale chips beard jianbing tousled. Chambray dreamcatcher trust fund, kitsch vice godard disrupt ramps hexagon mustache umami snackwave tilde chillwave ugh. Pour-over meditation PBR&B pickled ennui celiac mlkshk freegan photo booth af fingerstache pitchfork.",
  },
  {
    id: 6,
    contentHeading: "Who Are We and What Are Our Goals?",
    contentDescription:
      "Meggings portland fingerstache lyft, post-ironic fixie man bun banh mi umami everyday carry hexagon locavore direct trade art party. Locavore small batch listicle gastropub farm-to-table lumbersexual salvia messenger bag. Coloring book flannel truffaut craft beer drinking vinegar sartorial, disrupt fashion axe normcore meh butcher. Portland 90's scenester vexillologist forage post-ironic asymmetrical, chartreuse disrupt butcher paleo intelligentsia pabst before they sold out four loko. 3 wolf moon brooklyn.",
  },
  {
    id: 7,
    contentHeading: "Some of Our Past Activities",
    contentDescription:
      "Meggings kinfolk echo park stumptown DIY, kale chips beard jianbing tousled. Chambray dreamcatcher trust fund, kitsch vice godard disrupt ramps hexagon mustache umami snackwave tilde chillwave ugh. Pour-over meditation PBR&B pickled ennui celiac mlkshk freegan photo booth af fingerstache pitchfork.",
  },
  {
    id: 8,
    contentHeading: "Our Team",
    contentDescription:
      "Whatever cardigan tote bag tumblr hexagon brooklyn asymmetrical gentrify, subway tile poke farm-to-table. Franzen you probably haven't heard of them.",
  },
  {
    id: 9,
    contentHeading: "Some of Our Memorable Moments",
    contentDescription:
      "Whatever cardigan tote bag tumblr hexagon brooklyn asymmetrical gentrify, subway tile poke farm-to-table. Franzen you probably haven't heard of them man bun deep jianbing selfies heirloom.",
  },
];

export default PAGE_CONTENT;
